export const browserWindow = {
    adjustDimensions: (context) => {
        context.setState({
            width: window.innerWidth,
            height: window.innerHeight
        })
    }
}
